"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlockwellWallet = void 0;
exports.apiMinerEventsToLog = apiMinerEventsToLog;
exports.blockwellFactory = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _dumbapp = require("@blockwell/dumbapp");
var _chains = require("@blockwell/chains");
var _remeda = require("remeda");
var _WalletSubmissionStep = require("./WalletSubmissionStep");
var _fastDeepEqual = _interopRequireDefault(require("fast-deep-equal"));
var _BlockwellContext = require("./BlockwellContext");
const compareFields = ["status", "transactionHash", "events", "error", "created", "ended", "network", "waitForAsset", "from"];
class BlockwellWallet extends _dumbapp.ExecutorBase {
  get type() {
    return this.context.type;
  }
  get events() {
    return this.context.events;
  }
  get state() {
    return this.stateHolder.state;
  }
  constructor(context, parameters) {
    super();
    (0, _defineProperty2.default)(this, "api", void 0);
    (0, _defineProperty2.default)(this, "stateHolder", {
      state: "ready"
    });
    (0, _defineProperty2.default)(this, "prepare", async state => {
      let id;
      if (state.simulation) {
        id = "";
      } else {
        if (!this.context.account) {
          this.connect().catch(console.error);
          return {
            success: false,
            code: "auth_required",
            message: "Must be signed in to use Blockwell Wallet."
          };
        }
        id = _dumbapp.Dumbapp.uuid(state.dumbapp.shortcode, state.created, this.context.account);
      }
      return {
        success: true,
        data: {
          ...state,
          id,
          wallet: {
            type: "wallet",
            account: this.context.account
          }
        }
      };
    });
    (0, _defineProperty2.default)(this, "execute", async (state, args) => {
      let res = await this.performExecute(state, args);
      if (res.success === true) {
        return {
          success: true,
          data: res.data
        };
      } else {
        return res;
      }
    });
    this.context = context;
    this.parameters = parameters;
    this.api = parameters.walletApi;
  }
  async checkConnection() {
    if (this.api.loggedIn()) {
      this.context.account = await this.api.getAccount();
      this.newState("accounts-loaded");
      return true;
    }
    this.newState("ready");
    return false;
  }
  async connect() {
    let state = await this.api.connect();
    this.newState(state);
    return this.state;
  }
  estimateGas(state, step, args) {
    let net = (0, _chains.getChain)(args.chainId);
    return _dumbapp.EthExecutor.estimateGas({
      net,
      from: state.wallet.account
    }, state.dumbapp, step, args, net);
  }
  getAccount() {
    return this.context.account;
  }
  register(controller) {
    controller.addHandler("BlockwellWallet", "prepareWallet", this.prepare);
    controller.addHandler("BlockwellWallet", "execute", this.execute);
  }
  unregister(controller) {
    controller.removeHandler("BlockwellWallet");
  }
  requestNetwork(network) {
    return Promise.resolve(0);
  }
  newState(state) {
    if (state) {
      this.stateHolder.state = state;
    }
    let data = {
      type: "wallet",
      state: this.state,
      account: this.context.account,
      chainId: this.context.chainId
    };
    this.events.emit("connection", data);
  }
  async updateStatus(submission) {
    let data = submission.data;
    let steps = [];
    let changed = false;
    for (let step of data.steps) {
      if (step instanceof _WalletSubmissionStep.WalletSubmissionStep && (step.status === "new" || step.status === "nonce" || step.status === "submitted")) {
        try {
          let res = await this.api.getTransaction(step.id);
          let update = (0, _remeda.pick)(res, compareFields);
          if (!(0, _fastDeepEqual.default)(update, (0, _remeda.pick)(step, compareFields))) {
            // TODO: This can be removed once everything uses the newer Decoder
            let events = apiMinerEventsToLog(res.events);
            steps.push(new _WalletSubmissionStep.WalletSubmissionStep({
              ...step,
              ...update,
              events
            }, step.index));
            changed = true;
          } else {
            steps.push(new _WalletSubmissionStep.WalletSubmissionStep(step, step.index));
          }
        } catch (err) {
          return this.resultForError(err);
        }
      } else {
        steps.push(new _WalletSubmissionStep.WalletSubmissionStep(step, step.index));
      }
    }
    if (changed) {
      let cloned = (0, _remeda.clone)(data);
      cloned.steps = steps;
      let dat = new _dumbapp.DumbappSubmissionData(cloned);
      return {
        success: true,
        data: dat
      };
    }
    return {
      success: true,
      data: null
    };
  }
  async performExecute(state, args) {
    try {
      let data = await this.api.submitDumbapp({
        shortcode: state.dumbapp.shortcode,
        id: state.id,
        created: state.created,
        args: args.map(it => (0, _remeda.omit)(it, ["contract"])),
        inputs: state.data,
        qex: state.qex,
        extras: state.extras
      });
      return {
        success: true,
        data
      };
    } catch (err) {
      return this.resultForError(err);
    }
  }
}
exports.BlockwellWallet = BlockwellWallet;
function apiMinerEventsToLog(apiminerEvents) {
  let events = undefined;
  if (apiminerEvents && apiminerEvents.length > 0) {
    events = apiminerEvents.map(it => {
      let params = [];
      if (!it) {
        return null;
      }
      if (it.returnValues) {
        for (let [name, value] of Object.entries(it.returnValues)) {
          if (!/^\d/.test(name)) {
            if (Array.isArray(value)) {
              let type = "any";
              if (typeof value[0] === "boolean") {
                type = "bool";
              }
              params.push({
                name,
                type,
                values: value
              });
            } else {
              let type = "any";
              if (typeof value === "boolean") {
                type = "bool";
              }
              params.push({
                name,
                type,
                value
              });
            }
          }
        }
      }
      let log = {
        ...it,
        params,
        blockHash: null
      };
      return log;
    });
  }
  return events;
}
const blockwellFactory = exports.blockwellFactory = {
  async createWallet(parameters, window) {
    let context = window.dumbappNamespace.getContext("wallet");
    if (!context) {
      context = new _BlockwellContext.BlockwellContext();
      window.dumbappNamespace.addContext(context);
    }
    return new BlockwellWallet(context, parameters);
  },
  type: "wallet"
};
//# sourceMappingURL=BlockwellWallet.js.map